<template>
  <div class="reinvite__wrapper">
    <b-button variant="primary" class="reinvite__button" @click="reinviteUsers()">
       <b-spinner v-if="sending" small label="Spinning" />
      <span v-else>Invite Unconfirmed Users</span>
    </b-button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ReinviteAllUsersButton",
  props: {
    projectId: { type: String, default: '' }
  },
  data(){
    return {
      sending: false
    };
  },
  methods: {
    reinviteUsers() {
      this.sending = true;
      axios
        .post(`${this.$api_url}/projects/${this.projectId}/send-signup-invite`, null, this.getReqConfig())
        .catch(error => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }
}

</script>

<style lang="scss" scoped>
.reinvite {
  &__wrapper {
    display: flex;
    justify-content: flex-end;
  }
  &__button {
    margin-bottom: 20px;
    width: 220px;
  }
}
</style>